import React from "react";
import "./Affiliation.css";

function Affiliation() {
  return (
    <section className="affiliation-section">
      <div className="container text-center">
        <h2 className="affiliation-title">Affiliation & Recognition</h2>
      </div>

      <div className="logo-carousel-container">
        <div className="logo-carousel-track">
          <img src="/images/logo1.webp" alt="PMDC Logo" className="affiliation-logo" />
          <img src="/images/logo2.png" alt="Punjab Govt Logo" className="affiliation-logo" />
          <img src="/images/logo3.webp" alt="UHS Lahore Logo" className="affiliation-logo" />
          <img src="/images/logo4.png" alt="Hospital Logo" className="affiliation-logo" />

          <img src="/images/logo1.webp" alt="PMDC Logo" className="affiliation-logo" />
          <img src="/images/logo2.png" alt="Punjab Govt Logo" className="affiliation-logo" />
          <img src="/images/logo3.webp" alt="UHS Lahore Logo" className="affiliation-logo" />
          <img src="/images/logo4.png" alt="Hospital Logo" className="affiliation-logo" />

          <img src="/images/logo1.webp" alt="PMDC Logo" className="affiliation-logo" />
          <img src="/images/logo2.png" alt="Punjab Govt Logo" className="affiliation-logo" />
          <img src="/images/logo3.webp" alt="UHS Lahore Logo" className="affiliation-logo" />
          <img src="/images/logo4.png" alt="Hospital Logo" className="affiliation-logo" />
        </div>
      </div>
    </section>
  );
}

export default Affiliation;
